import React, { Component, Fragment } from 'react';

import Button from '../../../core/Buttons';
import DropdownInput from '../../../core/DropdownInput';

import { userAddress } from '../../../../constants/address';

import { FormColumns, FormColumn, Input } from '.';

import {
  addressType,
  provinces,
  countries,
  getDataFormatted
} from '../../../../utils/address';

import {
  StyledAccountFormBtnContent,
  StyledAddressFormTitle,
  StyledForm,
  StyledFormLabel,
  StyledButtonCancel
} from './style';

const selectDataFormatted = list =>
  list.map(item => ({
    text: item.text,
    value: item.key
  }));

class AddressForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      tipoDeVia: {
        value: props.address.idSiglaDomicilio,
        text: getDataFormatted(props.address.idSiglaDomicilio, 'addressType'),
        hasChanged: false
      },
      calle: {
        value: props.address.viaPublica,
        hasChanged: false
      },
      numero: {
        value: props.address.numeroVia,
        hasChanged: false
      },
      bloque: {
        value: props.address.bloque,
        hasChanged: false
      },
      piso: {
        value: props.address.piso,
        hasChanged: false
      },
      puerta: {
        value: props.address.puerta,
        hasChanged: false
      },
      escalera: {
        value: props.address.escalera,
        hasChanged: false
      },
      cpostal: {
        value: props.address.distritoPostal,
        hasChanged: false
      },
      poblacion: {
        value: props.address.poblacion,
        hasChanged: false
      },
      telefono: {
        value: props.address.telefono,
        hasChanged: false
      },
      provincia: {
        value: props.address.subdivGeo,
        text: getDataFormatted(`${props.address.subdivGeo}`, 'provinces'),
        hasChanged: false
      },
      pais: {
        value: props.address.nacion ? props.address.nacion : '011',
        text: props.address.nacion
          ? getDataFormatted(props.address.nacion, 'countries')
          : 'ESPAÑA',
        hasChanged: false
      },
      email: {
        value: props.address.email,
        hasChanged: false
      },
      disabledProvinceSelect: false
    };
  }

  handleOnSend = () => {
    const { onSend } = this.props;
    const userAddress = {
      idSiglaDomicilio: this.state.tipoDeVia.value,
      viaPublica: this.state.calle.value,
      numeroVia: this.state.numero.value,
      bloque: this.state.bloque.value,
      piso: this.state.piso.value,
      puerta: this.state.puerta.value,
      escalera: this.state.escalera.value,
      distritoPostal: this.state.cpostal.value,
      poblacion: this.state.poblacion.value,
      subdivGeo: this.state.provincia.value,
      nacion: this.state.pais.value,
      telefono: this.state.telefono.value,
      email: this.state.email.value,
      idEmpleado: null,
      idSociedad: null
    };
    if (onSend && userAddress.subdivGeo && userAddress.nacion) {
      onSend(userAddress);
    }
  };

  render() {
    const { address, onBack, formUser } = this.props;

    const {
      tipoDeVia,
      calle,
      numero,
      bloque,
      escalera,
      piso,
      puerta,
      cpostal,
      poblacion,
      provincia,
      pais,
      telefono,
      email,
      disabledProvinceSelect
    } = this.state;

    const dataHasChanged =
      tipoDeVia.hasChanged ||
      calle.hasChanged ||
      numero.hasChanged ||
      bloque.hasChanged ||
      escalera.hasChanged ||
      piso.hasChanged ||
      puerta.hasChanged ||
      cpostal.hasChanged ||
      poblacion.hasChanged ||
      provincia.hasChanged ||
      pais.hasChanged ||
      telefono.hasChanged ||
      email.hasChanged;

    return (
      <Fragment>
        <StyledForm>
          <StyledAddressFormTitle>
            {userAddress.addressForm.title}
          </StyledAddressFormTitle>
          <FormColumns>
            <FormColumn>
              <StyledFormLabel>
                {userAddress.addressForm.fields.tipoDeVia.label}
              </StyledFormLabel>
              <DropdownInput
                list={selectDataFormatted(addressType)}
                label={tipoDeVia.text || 'Selecciona una opcion'}
                value={tipoDeVia.text}
                onSelect={itemSelected =>
                  this.setState({
                    tipoDeVia: {
                      text: itemSelected.text,
                      value: itemSelected.value,
                      hasChanged:
                        itemSelected.value !== address.idSiglaDomicilio
                    }
                  })
                }
                small
              />
            </FormColumn>
            <FormColumn>
              <StyledFormLabel htmlFor="calle">
                {userAddress.addressForm.fields.calle.label}
              </StyledFormLabel>
              <Input
                name="calle"
                id="calle"
                value={calle.value}
                onChange={value =>
                  this.setState({
                    calle: {
                      value,
                      hasChanged: value !== address.viaPublica
                    }
                  })
                }
              />
            </FormColumn>
            <FormColumn mobile="50%" tablet="33.333%" desktop="50%">
              <StyledFormLabel htmlFor="numero">
                {userAddress.addressForm.fields.numero.label}
              </StyledFormLabel>
              <Input
                name="numero"
                id="numero"
                value={numero.value}
                onChange={value =>
                  this.setState({
                    numero: {
                      value,
                      hasChanged: value !== address.numeroVia
                    }
                  })
                }
                small
              />
            </FormColumn>
            <FormColumn mobile="50%" tablet="33.333%" desktop="50%">
              <StyledFormLabel htmlFor="bloque">
                {userAddress.addressForm.fields.bloque.label}
              </StyledFormLabel>
              <Input
                name="bloque"
                id="bloque"
                valid
                value={bloque.value}
                onChange={value =>
                  this.setState({
                    bloque: {
                      value,
                      hasChanged: value !== address.bloque
                    }
                  })
                }
                small
              />
            </FormColumn>
            <FormColumn mobile="50%" tablet="33.333%" desktop="50%">
              <StyledFormLabel htmlFor="escalera">
                {userAddress.addressForm.fields.escalera.label}
              </StyledFormLabel>
              <Input
                name="escalera"
                id="escalera"
                valid
                value={escalera.value}
                onChange={value =>
                  this.setState({
                    escalera: {
                      value,
                      hasChanged: value !== address.escalera
                    }
                  })
                }
                small
              />
            </FormColumn>
            <FormColumn mobile="50%" tablet="33.333%" desktop="50%">
              <StyledFormLabel htmlFor="piso">
                {userAddress.addressForm.fields.piso.label}
              </StyledFormLabel>
              <Input
                name="piso"
                id="piso"
                valid
                value={piso.value}
                onChange={value =>
                  this.setState({
                    piso: {
                      value,
                      hasChanged: value !== address.piso
                    }
                  })
                }
                small
              />
            </FormColumn>
            <FormColumn mobile="50%" tablet="33.333%" desktop="50%">
              <StyledFormLabel htmlFor="puerta">
                {userAddress.addressForm.fields.puerta.label}
              </StyledFormLabel>
              <Input
                name="puerta"
                id="puerta"
                valid
                value={puerta.value}
                onChange={value =>
                  this.setState({
                    puerta: {
                      value,
                      hasChanged: value !== address.puerta
                    }
                  })
                }
                small
              />
            </FormColumn>
            <FormColumn mobile="50%" tablet="33.333%" desktop="50%">
              <StyledFormLabel htmlFor="cpostal">
                {userAddress.addressForm.fields.cpostal.label}
              </StyledFormLabel>
              <Input
                name="cpostal"
                id="cpostal"
                valid
                value={cpostal.value}
                onChange={value =>
                  this.setState({
                    cpostal: {
                      value,
                      hasChanged: value !== address.distritoPostal
                    }
                  })
                }
                small
              />
            </FormColumn>
            <FormColumn desktop="50%">
              <StyledFormLabel htmlFor="poblacion">
                {userAddress.addressForm.fields.poblacion.label}
              </StyledFormLabel>
              <Input
                name="poblacion"
                id="poblacion"
                valid
                value={poblacion.value}
                onChange={value =>
                  this.setState({
                    poblacion: {
                      value,
                      hasChanged: value !== address.poblacion
                    }
                  })
                }
              />
            </FormColumn>
            {pais.value === '011' && (
              <FormColumn desktop="50%">
                <StyledFormLabel htmlFor="provincia">
                  {userAddress.addressForm.fields.provincia.label}
                </StyledFormLabel>
                <DropdownInput
                  disabled={disabledProvinceSelect}
                  list={selectDataFormatted(provinces)}
                  label={provincia.text || 'Selecciona una opcion'}
                  error={!provincia.value}
                  value={provincia.text}
                  onSelect={itemSelected =>
                    this.setState({
                      provincia: {
                        text: itemSelected.text,
                        value: itemSelected.value,
                        hasChanged:
                          itemSelected.value !== `${address.subdivGeo}`
                      }
                    })
                  }
                  small
                />
              </FormColumn>
            )}
            <FormColumn desktop="50%">
              <StyledFormLabel htmlFor="pais">
                {userAddress.addressForm.fields.pais.label}
              </StyledFormLabel>
              <DropdownInput
                list={selectDataFormatted(countries)}
                label={pais.text || 'Selecciona una opcion'}
                error={!pais.value}
                value={pais.text}
                onSelect={itemSelected =>
                  this.setState({
                    disabledProvinceSelect: itemSelected.value !== '011',
                    pais: {
                      text: itemSelected.text,
                      value: itemSelected.value,
                      hasChanged: itemSelected.value !== address.nacion
                    }
                  })
                }
                small
              />
            </FormColumn>
            <FormColumn desktop="50%">
              <StyledFormLabel htmlFor="telefono">
                {userAddress.addressForm.fields.telefono.label}
              </StyledFormLabel>
              <Input
                name="telefono"
                id="telefono"
                valid
                value={telefono.value}
                onChange={value =>
                  this.setState({
                    telefono: {
                      value,
                      hasChanged: value !== address.telefono
                    }
                  })
                }
              />
            </FormColumn>
            {!formUser && (
              <FormColumn desktop="50%">
                <StyledFormLabel htmlFor="email">
                  {userAddress.addressForm.fields.email.label}
                </StyledFormLabel>
                <Input
                  name="email"
                  id="email"
                  valid
                  value={email.value}
                  onChange={value =>
                    this.setState({
                      email: {
                        value,
                        hasChanged: value !== address.email
                      }
                    })
                  }
                />
              </FormColumn>
            )}
          </FormColumns>
          <StyledAccountFormBtnContent>
            <StyledButtonCancel ghost dark onClick={onBack}>
              Cancelar
            </StyledButtonCancel>
            <Button
              secondary
              disabled={!dataHasChanged}
              onClick={() => this.handleOnSend()}
            >
              {userAddress.addressForm.btn}
            </Button>
          </StyledAccountFormBtnContent>
        </StyledForm>
      </Fragment>
    );
  }
}

export default AddressForm;
